import { Box, Stack, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { formatUSPhoneNumber } from '@product-framework/components/FormFields/PhoneNumber';
import { IconChip } from '@product-framework/components/PageSection';
import { IconLibrary } from '@product-framework/index';
import TextLabelValue from '../components/TextLabelValue';
import NotAvailable from '../components/NotAvailable';

function ContactSection({ location }) {
  return (
    <Box>
      <Stack
        direction="row"
        spacing={0.5}
        sx={{ alignItems: 'center', justifyContent: 'left', mb: 2 }}>
        <IconChip
          bgColor="primary.light"
          iconColor="primary.main"
          Icon={IconLibrary.Contact}
          size={30}
          iconFontSize="18px"
        />
        <Typography
          variant="subtitle2"
          color="text.secondary"
          sx={{ mt: -0.9, mb: 1 }}>
          <FormattedMessage
            id="CONTACT_INFORMATION"
            defaultMessage="Contact Information"
          />
        </Typography>
      </Stack>

      <Stack spacing={1}>
        <TextLabelValue
          id="SP_MAP_MODAL_PRIMARY_CONTACT"
          defaultMessage={
            <FormattedMessage
              id="PRIMARY_EMAIL"
              defaultMessage="Primary Email"
            />
          }
          value={location?.primaryContact?.email || <NotAvailable />}
        />

        <TextLabelValue
          id="SP_MAP_MODAL_CONTACT_DISPATCH_NOTIFICATIONS"
          defaultMessage={
            <FormattedMessage
              id="DISPATCH_NOTIFICATION_EMAIL"
              defaultMessage="Dispatch Notification Email"
            />
          }
          value={location?.dispatchNotificationEmail || <NotAvailable />}
        />

        <TextLabelValue
          id="SP_MAP_MODAL_CONTACT_DISPATCH_Phone"
          defaultMessage={
            <FormattedMessage id="PHONE" defaultMessage="Phone" />
          }
          value={
            location?.primaryContact?.phone ? (
              formatUSPhoneNumber(location?.primaryContact?.phone)
            ) : (
              <NotAvailable />
            )
          }
        />
      </Stack>
    </Box>
  );
}
export default ContactSection;
